import script from "./ManualJournalPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManualJournalPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./ManualJournalPopUp.vue?vue&type=style&index=0&id=7227d4fa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7227d4fa"]])

export default __exports__